.root {
  align-items: stretch;
  background: var(--color-secondary);
  border: 1px solid var(--color-border);
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 12px;
}

.actions {
  align-items: center;
  display: flex;
  gap: 8px;
  justify-content: flex-end;
}

.confirm-label {
  align-items: center;
  display: inline-flex;
  gap: 6px;
}
